import { Input, Select } from 'antd';

import { useIntl } from 'react-intl';
import { BrickCodeInput, Form, WrapperSelect } from 'common/components';
import { OverlayInputWrapper } from 'common/components/overlay';

import {
  checkActiveStatus,
  checkRequiredPrimaryFieldForm,
  clearValidatedFieldErrors,
  isUnitPackageLevel,
} from 'common/components/product-add/components/utils/validation';

import messages from 'i18n/messages/product';
import { PACKAGE_LEVELS } from 'static/Constants';
import { useCheckIsProductOverlay } from 'hooks';

const { Option } = Select;

export const ClassificationFieldset = (props) => {
  const {
    currentHierarchy,
    getOverlayProps,
    getBrickCodeOverlayProps,
    updateBrickCodeData,
    brick,
    getBrickCodeNameOverlayProps,
    onRevalidateProduct,
  } = props;

  const intl = useIntl();
  const isOverlay = useCheckIsProductOverlay();

  const formInstance = Form.useFormInstance();
  const isUnit = isUnitPackageLevel(
    Form.useWatch('packageLevel', formInstance)
  );

  const isActiveStatus = checkActiveStatus(Form.useWatch('status'));

  const packageLevelWarning =
    currentHierarchy?.productHierarchyId && !isOverlay
      ? {
          help: intl.formatMessage(messages.packageLevelTooltip),
          validateStatus: 'warning',
          hasFeedback: true,
        }
      : {};

  const disablePackageLevel = currentHierarchy?.productHierarchyId || isOverlay;

  return (
    <>
      <Form.Item
        name='packageLevel'
        label='Package Level'
        rules={[
          {
            required: true,
            message: intl.formatMessage(messages.productPackageLvRequired),
          },
        ]}
        {...packageLevelWarning}
      >
        <OverlayInputWrapper {...getOverlayProps('packageLevel')}>
          <WrapperSelect
            placeholder='Select a package level'
            disabled={disablePackageLevel}
            allowClear
            listHeight={160}
            getPopupContainer={() =>
              document.getElementById('classification-field')
            }
            onSelect={(value) => {
              if (isUnitPackageLevel(value)) {
                onRevalidateProduct && onRevalidateProduct();
              } else {
                clearValidatedFieldErrors(formInstance);
              }
            }}
          >
            {PACKAGE_LEVELS?.map((packageLevel, index) => (
              <Option value={packageLevel} key={index}>
                {packageLevel}
              </Option>
            ))}
          </WrapperSelect>
        </OverlayInputWrapper>
      </Form.Item>

      <Form.Item
        name='brick'
        label='Brick Code'
        rules={[
          {
            required: checkRequiredPrimaryFieldForm({
              isActiveStatus,
              isUnit,
            }),
            message: 'Brick Code is required',
          },
        ]}
      >
        <OverlayInputWrapper
          style={{ paddingRight: '10px' }}
          {...getBrickCodeOverlayProps()}
        >
          <BrickCodeInput
            updateBrickCodeData={updateBrickCodeData}
            initialValue={brick}
            disabled={isOverlay}
          />
        </OverlayInputWrapper>
      </Form.Item>
      <Form.Item label='Brick Code Name'>
        <OverlayInputWrapper {...getBrickCodeNameOverlayProps()}>
          <Input value={brick?.brickCodeName} disabled />
        </OverlayInputWrapper>
      </Form.Item>
    </>
  );
};
